import { EJStatus, Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useSoftRemoveEngineeringJudgementMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useEJLogContext } from '../../../../EJLogContext'
import { EngineeringJudgement } from '../../../../EJLogContext/types'

export function useRemove(): RemoveRowActionOptions<EngineeringJudgement> {
  const { refetch } = useEJLogContext()
  const [remove] = useSoftRemoveEngineeringJudgementMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveEngineeringJudgement: {
        judgement: { formattedNumber },
      },
    }) => simpleRemoveNotification(formattedNumber),
  })
  return {
    permission: Permission.RemoveRestoreEngineeringJudgement,
    disabled: ({ statusId }) =>
      statusId === EJStatus.Closed.id
        ? {
            message: `Cannot be removed while in status: ${EJStatus.Closed.name}`,
          }
        : false,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
